import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuildingUser } from '@fortawesome/free-solid-svg-icons/faBuildingUser';
import { faRepeat } from '@fortawesome/free-solid-svg-icons/faRepeat';
import { Button, Modal } from '../ui';
import { useProviderContextStore } from '../../stores';
import { ProviderContextBadge } from './ProviderContextBadge';
import { ProviderContextSelector } from './ProviderContextSelector';

export function ProviderContextMenu() {
    const navigate = useNavigate();
    const [selectorOpen, setSelectorOpen] = useState(false);
    const activeContext = useProviderContextStore((state) => state.activeContext);
    const canManageProvider = activeContext?.effective_permissions.some((permission) => (
        permission === 'users.manage'
        || permission === 'resource.assign'
        || permission === 'documents.manage'
        || permission === 'payments.manage'
        || permission === 'reports.view'
    )) ?? false;

    if (!activeContext) {
        return null;
    }

    return (
        <>
            <div className="border-b border-border bg-background px-4 py-2">
                <div className="mx-auto flex max-w-[600px] items-center gap-2">
                    <div className="min-w-0 flex-1">
                        <ProviderContextBadge onClick={() => setSelectorOpen(true)} />
                    </div>
                    {canManageProvider ? (
                        <button
                            type="button"
                            onClick={() => navigate('/providers/panel')}
                            className="flex size-11 shrink-0 items-center justify-center rounded-xl bg-surface text-text transition active:bg-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/35"
                            aria-label="Panel del proveedor"
                        >
                            <FontAwesomeIcon icon={faBuildingUser} aria-hidden="true" />
                        </button>
                    ) : null}
                    <button
                        type="button"
                        onClick={() => setSelectorOpen(true)}
                        className="flex size-11 shrink-0 items-center justify-center rounded-xl bg-surface text-text transition active:bg-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/35"
                        aria-label="Cambiar contexto"
                    >
                        <FontAwesomeIcon icon={faRepeat} aria-hidden="true" />
                    </button>
                </div>
            </div>

            <Modal
                isOpen={selectorOpen}
                onClose={() => setSelectorOpen(false)}
                title="Contexto de proveedor"
                size="medium"
            >
                <ProviderContextSelector onSelected={() => setSelectorOpen(false)} />
                <div className="mt-4">
                    <Button type="button" variant="secondary" fullWidth onClick={() => setSelectorOpen(false)}>
                        Cerrar
                    </Button>
                </div>
            </Modal>
        </>
    );
}
